if (!customElements.get('wlsn-shatner-giveaway-modal')) {
  class WLSNShatnerGiveawayModal extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        open: 'is-open',
        bodyLockClass: 'body-lock',
        trigger: 'js-wlsn-shatner-giveaway-modal-trigger',
        close: 'js-wlsn-shatner-giveaway-modal-close',
        wrapper: 'js-wlsn-shatner-giveaway-modal-wrapper'
      };

      this.elements = {
        wrapper: this.querySelector(`.${this.classes.wrapper}`),
        closeBtn: this.querySelector(`.${this.classes.close}`)
      };

      this.lastTrigger = null;

      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {
      // Delegated so triggers work regardless of render order or theme editor reloads.
      document.addEventListener('click', this.handleTriggerClick);

      if (this.elements.closeBtn) {
        this.elements.closeBtn.addEventListener('click', this.handleCloseClick);
      }

      this.addEventListener('click', this.handleOutsideClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleTriggerClick);
      document.removeEventListener('keydown', this.handleKeydown);

      if (this.elements.closeBtn) {
        this.elements.closeBtn.removeEventListener('click', this.handleCloseClick);
      }

      this.removeEventListener('click', this.handleOutsideClick);
      document.body.classList.remove(this.classes.bodyLockClass);
    }

    handleTriggerClick(event) {
    const trigger = event.target.closest(`.${this.classes.trigger}, a[href*='#shatner-giveaway']`);

      if (!trigger) return;

      event.preventDefault();
      this.lastTrigger = trigger;
      this.open();
    }

    handleCloseClick() {
      this.close();
    }

    handleOutsideClick(event) {
      if (!this.elements.wrapper.contains(event.target)) {
        this.close();
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    open() {
      this.classList.add(this.classes.open);
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add(this.classes.bodyLockClass);
      document.addEventListener('keydown', this.handleKeydown);

      if (this.elements.closeBtn) {
        this.elements.closeBtn.focus({ preventScroll: true });
      }
    }

    close() {
      if (!this.classList.contains(this.classes.open)) return;

      this.classList.remove(this.classes.open);
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove(this.classes.bodyLockClass);
      document.removeEventListener('keydown', this.handleKeydown);

      if (this.lastTrigger) {
        this.lastTrigger.focus({ preventScroll: true });
        this.lastTrigger = null;
      }
    }
  }

  customElements.define('wlsn-shatner-giveaway-modal', WLSNShatnerGiveawayModal);
}
